export const START = '_START';
export const SUCCESS = '_SUCCESS';
export const FAIL = '_FAIL';

export const SAVE_ADMIN_SETUP = 'SAVE_ADMIN_SETUP';
